// extracted by mini-css-extract-plugin
export default {"backBtnWrapper":"BackButton_backBtnWrapper__9vgp8","leftAerrow":"BackButton_leftAerrow__7K6YJ"};